import { gql } from '@apollo/client';

export const getOpportunities = gql`
  query NE_opportunities($orgId: Int!) {

  groups: niaga_groups_organisation_list_all_export(filter: {organisation_id: $orgId}) {
      organisation_id
      organisation_name
      group_id
      group_name
      group_delta_boost
      plots {
        id
        name
        size
        location {
          province
          district
          subdistrict
          village
        }
        owner_organisation_id
        owner_organisation_name
        owner_transactor_id
        owner_firstname
        owner_lastname
        owner_avatar_url
      }
    }

    opportunities: ne_opportunities(filter: $orgId) {
      field_agent {
        person {
          first_name
          last_name
          phone_number
        }
      }
      opportunity {
        big_opportunity_details {
          current_price
          extraction_rate
          person_id
          tenera_ratio
          tonnage
          organisation_id
          organisation_name
          rejection_reason
          contact_position {
            coordinates
          }
          organisation_position {
            coordinates
          }
        }
        current_stage
        id
      }
    }
  }
`

export const acceptOpportunity = gql`
  mutation NE_acceptOpportunity($opportunity_id: Int!, $accept: Boolean!) {
    opp: ne_opportunities_accept(opportunity_id: $opportunity_id, accept: $accept) {
      field_agent {
        person {
          first_name
          last_name
          phone_number
        }
      }
      opportunity {
        big_opportunity_details {
          current_price
          extraction_rate
          person_id
          tenera_ratio
          tonnage
          organisation_id
          organisation_name
          contact_position {
            coordinates
          }
          organisation_position {
            coordinates
          }
        }
        current_stage
        id
      }
    }
  }
`